<form [formGroup]="form">
  <div class="grid">
    <div class="md:col-4">
      <label class="label">{{ translations.WATER_DAMAGE }}</label>
      <wr-tenant-select formControlName="waterDamageContractorId" [tenantType]="TenantFilterTypeEnum.Contractor"></wr-tenant-select>
    </div>
    <div class="md:col-4">
      <label class="label">{{ translations.HEATING_FAILURE }}</label>
      <wr-tenant-select formControlName="heatingFailureContractorId" [tenantType]="TenantFilterTypeEnum.Contractor"></wr-tenant-select>
    </div>
    <div class="md:col-4">
      <label class="label">{{ translations.STORM_DAMAGE }}</label>
      <wr-tenant-select formControlName="stormDamageContractorId" [tenantType]="TenantFilterTypeEnum.Contractor"></wr-tenant-select>
    </div>
  </div>
</form>
